/** 10DLC MARKETING campaign copy for optional Roma Club homepage opt-in. */

/** Public marketing long code (profile: Chef Roma Kitchen - Marketing). */
export const ROMA_CLUB_MARKETING_SMS_NUMBER_DISPLAY = "(702) 760-5074";
export const ROMA_CLUB_MARKETING_SMS_NUMBER_E164 = "+17027605074";

/** Live CTA path carriers should open for verification (homepage Roma Club block). */
export const ROMA_CLUB_SMS_OPT_IN_URL =
  "https://chefsromakitchen.com/#rewards";

/**
 * Checkbox label aligned to Telnyx marketing opt-in sample:
 * recurring, frequency estimate, rates, HELP/STOP, not a condition of purchase.
 */
export const ROMA_CLUB_SMS_MARKETING_CONSENT_LABEL =
  "By checking this box, you agree to receive recurring promotional and marketing text messages from Chef's Roma Kitchen via SMS (specials, seasonal menus, events). Message frequency varies (up to 8 msgs/month). Message and data rates may apply. Reply HELP for help, STOP to unsubscribe. Consent is not a condition of purchase.";

export const ROMA_CLUB_PRIVACY_NOTE_WITH_SMS =
  "Email is used for Roma Club updates. Optional promotional texts only if you check the SMS box above. Free to join. Unsubscribe anytime. Privacy: chefsromakitchen.com/privacy.";
